<template>
  <div class="app-container">
    <div class="head-container">
      <el-button type="primary" icon="el-icon-plus" size="small" @click="openForm()">新增供应商</el-button>
      <el-button icon="el-icon-search" size="small" @click="loadList">刷新</el-button>
      <span style="margin-left:12px;color:#909399;font-size:13px;">
        进货价按「供应商 × 触点规则 × 印章底部 × 手柄」维护；入库时自动带出并可改
      </span>
    </div>

    <el-table v-loading="loading" :data="list" size="small" border style="width:100%;margin-top:12px;">
      <el-table-column prop="supplierCode" label="编码" width="120" />
      <el-table-column prop="supplierName" label="供应商" min-width="120" />
      <el-table-column prop="contactName" label="联系人" width="100" />
      <el-table-column prop="contactPhone" label="电话" width="120" />
      <el-table-column prop="address" label="地址" min-width="140" show-overflow-tooltip />
      <el-table-column prop="sort" label="排序" width="72" align="center" />
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
            {{ scope.row.status === 1 ? '启用' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
      <el-table-column label="操作" width="260" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="openForm(scope.row)">编辑</el-button>
          <el-button type="text" size="mini" @click="openPriceDialog(scope.row)">进货价</el-button>
          <el-button type="text" size="mini" @click="copyProduceLink(scope.row)">生产看板链接</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="form.id ? '编辑供应商' : '新增供应商'" :visible.sync="formVisible" width="520px" :close-on-click-modal="false">
      <el-form ref="formRef" :model="form" label-width="100px" size="small">
        <el-form-item label="供应商编码" required>
          <el-input v-model="form.supplierCode" :disabled="!!form.id" maxlength="32" placeholder="如 CHANGZHOU" />
        </el-form-item>
        <el-form-item label="供应商名称" required>
          <el-input v-model="form.supplierName" maxlength="128" />
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="form.contactName" maxlength="64" />
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="form.contactPhone" maxlength="32" />
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="form.address" maxlength="256" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :max="9999" style="width:100%;" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="512" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="formVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="submitForm">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="'进货价维护 — ' + (priceSupplier.supplierName || '')"
      :visible.sync="priceVisible"
      width="900px"
      :close-on-click-modal="false"
    >
      <div style="margin-bottom:12px;">
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="openPriceForm()">新增进货价</el-button>
        <el-button size="mini" icon="el-icon-refresh" @click="loadPrices">刷新</el-button>
      </div>
      <el-table v-loading="priceLoading" :data="priceList" size="small" border>
        <el-table-column prop="skuName" label="物料" min-width="160" show-overflow-tooltip />
        <el-table-column prop="ruleName" label="触点规则" min-width="120" show-overflow-tooltip />
        <el-table-column prop="baseName" label="印章底部" min-width="120" show-overflow-tooltip />
        <el-table-column prop="handleName" label="手柄" width="110" />
        <el-table-column prop="ruleCode" label="规则编码" width="120" show-overflow-tooltip />
        <el-table-column label="进货价(元)" width="120" align="right">
          <template slot-scope="scope">
            {{ formatPrice(scope.row.purchasePrice) }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip />
        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="openPriceForm(scope.row)">改价</el-button>
            <el-button type="text" size="mini" style="color:#f56c6c;" @click="removePrice(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :title="priceForm.id ? '修改进货价' : '新增进货价'" :visible.sync="priceFormVisible" width="520px" append-to-body :close-on-click-modal="false">
      <el-form label-width="100px" size="small">
        <el-form-item label="触点规则" required>
          <el-select v-model="priceForm.ruleId" filterable placeholder="选择触点规则" style="width:100%;" :disabled="!!priceForm.id">
            <el-option v-for="c in ruleOptions" :key="c.id" :label="c.ruleName + ' (' + c.ruleCode + ')'" :value="c.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="印章底部" required>
          <el-select v-model="priceForm.baseId" filterable placeholder="选择印章底部" style="width:100%;" :disabled="!!priceForm.id">
            <el-option v-for="b in baseOptions" :key="b.id" :label="b.baseName + ' (' + b.baseCode + ')'" :value="b.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="手柄" required>
          <el-select v-model="priceForm.handleId" filterable placeholder="选择手柄" style="width:100%;" :disabled="!!priceForm.id">
            <el-option v-for="h in handleOptions" :key="h.id" :label="h.handleName" :value="h.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="进货价(元)" required>
          <el-input-number v-model="priceForm.purchasePrice" :min="0" :precision="4" :step="0.1" style="width:100%;" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="priceForm.remark" type="textarea" :rows="2" maxlength="512" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="priceFormVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="priceSaving" @click="submitPriceForm">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchSealSuppliers,
  createSealSupplier,
  updateSealSupplier,
  fetchSealSupplierPrices,
  saveSealSupplierPrice,
  deleteSealSupplierPrice,
  fetchEnabledSealRules,
  fetchEnabledSealBases,
  fetchEnabledSealHandles,
  ensureSealSupplierAccessToken
} from '@/api/h5-admin-seal-stock'

export default {
  name: 'H5AdminSealSupplier',
  data() {
    return {
      loading: false,
      saving: false,
      list: [],
      formVisible: false,
      form: this.emptyForm(),
      priceVisible: false,
      priceLoading: false,
      priceSaving: false,
      priceSupplier: {},
      priceList: [],
      priceFormVisible: false,
      priceForm: { id: null, supplierId: null, ruleId: null, baseId: null, handleId: null, purchasePrice: 0, remark: '' },
      ruleOptions: [],
      baseOptions: [],
      handleOptions: []
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    emptyForm() {
      return {
        id: null,
        supplierCode: '',
        supplierName: '',
        contactName: '',
        contactPhone: '',
        address: '',
        sort: 0,
        status: 1,
        remark: ''
      }
    },
    formatPrice(v) {
      if (v == null || v === '') return '—'
      return Number(v).toFixed(4)
    },
    loadList() {
      this.loading = true
      fetchSealSuppliers({ page: 0, size: 100 })
        .then((res) => {
          const data = (res && res.data) || {}
          this.list = data.content || []
        })
        .catch(() => {
          this.list = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    openForm(row) {
      if (row && row.id) {
        this.form = {
          id: row.id,
          supplierCode: row.supplierCode || '',
          supplierName: row.supplierName || '',
          contactName: row.contactName || '',
          contactPhone: row.contactPhone || '',
          address: row.address || '',
          sort: row.sort != null ? row.sort : 0,
          status: row.status != null ? row.status : 1,
          remark: row.remark || ''
        }
      } else {
        this.form = this.emptyForm()
      }
      this.formVisible = true
    },
    submitForm() {
      if (!this.form.supplierName || !String(this.form.supplierName).trim()) {
        this.$message.warning('请填写供应商名称')
        return
      }
      if (!this.form.id && (!this.form.supplierCode || !String(this.form.supplierCode).trim())) {
        this.$message.warning('请填写供应商编码')
        return
      }
      this.saving = true
      const req = this.form.id ? updateSealSupplier(this.form) : createSealSupplier(this.form)
      req
        .then(() => {
          this.$message.success('保存成功')
          this.formVisible = false
          this.loadList()
        })
        .finally(() => {
          this.saving = false
        })
    },
    openPriceDialog(row) {
      this.priceSupplier = row || {}
      this.priceVisible = true
      this.loadOptions().then(() => this.loadPrices())
    },
    loadOptions() {
      return Promise.all([
        fetchEnabledSealRules().then((res) => {
          this.ruleOptions = (res && res.data) || []
        }),
        fetchEnabledSealBases().then((res) => {
          this.baseOptions = (res && res.data) || []
        }),
        fetchEnabledSealHandles().then((res) => {
          this.handleOptions = (res && res.data) || []
        })
      ]).catch(() => {})
    },
    loadPrices() {
      if (!this.priceSupplier.id) return
      this.priceLoading = true
      fetchSealSupplierPrices(this.priceSupplier.id)
        .then((res) => {
          this.priceList = (res && res.data) || []
        })
        .catch(() => {
          this.priceList = []
        })
        .finally(() => {
          this.priceLoading = false
        })
    },
    openPriceForm(row) {
      if (row && row.id) {
        this.priceForm = {
          id: row.id,
          supplierId: this.priceSupplier.id,
          ruleId: row.ruleId,
          baseId: row.baseId,
          handleId: row.handleId,
          purchasePrice: row.purchasePrice != null ? Number(row.purchasePrice) : 0,
          remark: row.remark || ''
        }
      } else {
        this.priceForm = {
          id: null,
          supplierId: this.priceSupplier.id,
          ruleId: null,
          baseId: null,
          handleId: null,
          purchasePrice: 0,
          remark: ''
        }
      }
      this.priceFormVisible = true
    },
    submitPriceForm() {
      if (!this.priceForm.ruleId || !this.priceForm.baseId || !this.priceForm.handleId) {
        this.$message.warning('请选择触点规则、印章底部与手柄')
        return
      }
      if (this.priceForm.purchasePrice == null || this.priceForm.purchasePrice < 0) {
        this.$message.warning('请填写有效进货价')
        return
      }
      this.priceSaving = true
      saveSealSupplierPrice({
        id: this.priceForm.id,
        supplierId: this.priceSupplier.id,
        ruleId: this.priceForm.ruleId,
        baseId: this.priceForm.baseId,
        handleId: this.priceForm.handleId,
        purchasePrice: this.priceForm.purchasePrice,
        remark: this.priceForm.remark
      })
        .then(() => {
          this.$message.success('进货价已保存')
          this.priceFormVisible = false
          this.loadPrices()
        })
        .finally(() => {
          this.priceSaving = false
        })
    },
    removePrice(row) {
      if (!row || !row.id) return
      this.$confirm('确认删除该进货价？', '提示', { type: 'warning' })
        .then(() => deleteSealSupplierPrice(row.id))
        .then(() => {
          this.$message.success('已删除')
          this.loadPrices()
        })
        .catch(() => {})
    },
    buildProduceLink(token) {
      const origin = window.location.origin
      const base = (process.env.BASE_URL || '/').replace(/\/?$/, '/')
      // 生产部署常见 /h5/；开发环境根路径
      const prefix = base === '/' ? '' : base.replace(/\/$/, '')
      return `${origin}${prefix}/seal/supplier-produce?token=${encodeURIComponent(token)}`
    },
    copyProduceLink(row) {
      if (!row || !row.id) return
      const doCopy = (token) => {
        const link = this.buildProduceLink(token)
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(link).then(() => {
            this.$message.success('生产看板链接已复制')
          }).catch(() => {
            this.$alert(link, '请手动复制链接', { confirmButtonText: '关闭' })
          })
        } else {
          this.$alert(link, '请手动复制链接', { confirmButtonText: '关闭' })
        }
      }
      if (row.accessToken) {
        doCopy(row.accessToken)
        return
      }
      ensureSealSupplierAccessToken(row.id).then((res) => {
        const data = (res && res.data) || {}
        const token = data.accessToken
        if (!token) {
          this.$message.error('生成访问令牌失败')
          return
        }
        row.accessToken = token
        doCopy(token)
      })
    }
  }
}
</script>
